import { useModalState } from '@/shared/hooks';
import { useProjectCapabilities } from '@/entities/user';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { getProjectOwnerId } from '@/entities/project';
import type { ProjectDetail } from '@/entities/project';

export function useProjectMembersModal(project: ProjectDetail | undefined) {
  const modal = useModalState();
  const workspaceId = useCurrentWorkspaceId();
  const projects = useProjectCapabilities();

  return {
    isOpen: modal.isOpen,
    isMounted: modal.isMounted,
    open: modal.open,
    close: modal.close,
    instanceKey: modal.instanceKey,
    workspaceId,
    canShare: !!project?.platformProjectId && projects.canManageMembers,
    platformProjectId: project?.platformProjectId,
    ownerId: getProjectOwnerId(project),
  };
}
